import { MainChannel } from './webChannel';
import { BRIDGE_RESPONSE_TYPE, BRIDGE_RESPONSE_CODE } from '../interface/webMainDriver';
import { inWindow } from '@/config';
import { isSupportNativeProxy } from '@/api/util';
export class MainBridgeEngine {
    constructor() {
        this.taskStackMap = new Map();
        this.mainChannelApi = new MainChannel();
        this.taskListInProcess = new Map();
        this.bgDataWinList = new Map();
        this.priorityConfigMap = new Map([
            [
                'mail.saveMails',
                {
                    priority: 'high',
                    overtime: 5 * 1000,
                },
            ],
        ]);
        this.responseTimeoutManageMap = new Map();
        this.consumingDurationManageMap = new Map();
        this.pullingLockMap = new Map();
        this.traverseTimeMap = new Map();
        if (inWindow() && isSupportNativeProxy) {
            this.delayInit();
        }
    }
    async delayInit() {
        await new Promise(r => setTimeout(r, 100));
        this.initIpcChannel();
    }
    createSubPage() {
        console.log('[bridge.web]1.26版本之后web不在创建iframe页面');
    }
    removeSubPage() {
        const bgIframe = document.getElementById('accountBgEntry');
        bgIframe === null || bgIframe === void 0 ? void 0 : bgIframe.remove();
    }
    initIpcChannel() {
        this.mainChannelApi.registerHandleCallback('dispatchTask', async (e, params) => {
            console.log('[web-bridge]dispatchTask.invoked', e, params);
            const channelId = e.data.channelId;
            const data = await this.dispatchTask(e, Object.assign(Object.assign({}, params), { channelId }));
            return Promise.resolve({ data });
        });
        this.mainChannelApi.registerHandleCallback('returnTaskResult', async (e, params) => {
            const data = await this.returnTaskResult(e, params);
            return Promise.resolve({ data });
        });
        this.mainChannelApi.registerHandleCallback('registerTaskHandleWin2Main', async (e, args) => {
            console.log('[web-bridge]registerTaskHandleWin2Main.invoked', e, args);
            const data = await this.registerTaskHandleWin2Main();
            return Promise.resolve({ data });
        });
        this.mainChannelApi.registerHandleCallback('flush', async (e, args) => {
            console.log('[web-bridge]flush.invoked', e, args);
            const data = await this.flush(args);
            return Promise.resolve({ data });
        });
        this.mainChannelApi.registerHandleCallback('getAllTasks', async (e, args) => {
            console.log('[web-bridge]flush.getAllTasks', e, args);
            const data = await this.getAllTasks(args);
            return Promise.resolve(data);
        });
        this.mainChannelApi.registerHandleCallback('configureApiPriority', async (e, args) => {
            console.log('[web-bridge]configureApiPriority.invoked', e, args);
            const data = await this.configureApiPriority(args);
            return Promise.resolve(data);
        });
        this.mainChannelApi.registerHandleCallback('getConfigureTaskPriority', async () => {
            const data = await this.getConfigureTaskPriority();
            return Promise.resolve(data);
        });
        this.mainChannelApi.registerHandleCallback('ping', async (e, args) => {
            const channelId = e.data.channelId;
            this.delayDetectBgWin(channelId, args);
            return true;
        });
        this.mainChannelApi.registerHandleCallback('broadcastEvent2All', async (e, args) => {
            console.warn('[web-bridge]broadcastEvent2All', e, args);
            const { businessEventName: eventname, params } = args;
            this.mainChannelApi.broadcast({
                eventname,
                args: params,
            }, {
                excludeSelf: true,
                selfChannelId: e.data.channelId,
            });
        });
    }
    async flush(account) {
        if (!account || !account.length) {
            [...this.taskStackMap.keys()].map(accountItem => this.flush(accountItem));
            return true;
        }
        if (!this.taskStackMap.has(account)) {
            return true;
        }
        const taskStack = this.taskStackMap.get(account);
        [...taskStack.highTasks, ...taskStack.mediumTasks, ...taskStack.timeoutTasks].forEach(item => {
            const { reject } = item;
            typeof reject === 'function' && reject(new Error(BRIDGE_RESPONSE_TYPE.BG_WIN_UNRESPONSE));
        });
        const keys = [...this.taskListInProcess.keys()].filter(item => this.taskListInProcess.get(item).requestContent.account === account);
        keys.forEach(ackNo => {
            this.doReturn2JobQ({
                ackNo: ackNo,
                code: BRIDGE_RESPONSE_CODE.BG_WIN_UNRESPONSE,
                errorMsg: BRIDGE_RESPONSE_TYPE.BG_WIN_UNRESPONSE,
            });
            this.taskListInProcess.delete(ackNo);
        });
        return true;
    }
    configureApiPriority(config) {
        const { taskInfo, priority } = config;
        const defaultOvertime = MainBridgeEngine.DefaultTimeoutResponseTime.has(priority)
            ? MainBridgeEngine.DefaultTimeoutResponseTime.get(priority)
            : Infinity;
        const key = [taskInfo.namespace, taskInfo.apiname].join('.');
        this.priorityConfigMap.set(key, {
            priority,
            overtime: (config.overtime || defaultOvertime),
        });
        return true;
    }
    getConfigureTaskPriority() {
        return this.priorityConfigMap;
    }
    async getAllTasks(account) {
        if (!this.taskStackMap.has(account)) {
            return {};
        }
        const totalTasks = [...this.taskStackMap.values()];
        return {
            highTaskStatck: totalTasks
                .map(item => item.highTasks)
                .flat(1)
                .map(item => {
                const _item = Object.assign({}, item);
                Reflect.deleteProperty(_item, 'resolve');
                Reflect.deleteProperty(_item, 'reject');
                return _item;
            }),
            mediumTaskStack: totalTasks
                .map(item => item.mediumTasks)
                .flat(1)
                .map(item => {
                const _item = Object.assign({}, item);
                Reflect.deleteProperty(_item, 'resolve');
                Reflect.deleteProperty(_item, 'reject');
                return _item;
            }),
            lowTaskStack: totalTasks
                .map(item => item.lowTasks)
                .flat(1)
                .map(item => {
                const _item = Object.assign({}, item);
                Reflect.deleteProperty(_item, 'resolve');
                Reflect.deleteProperty(_item, 'reject');
                return _item;
            }),
            timeoutStatck: totalTasks
                .map(item => item.timeoutTasks)
                .flat(1)
                .map(item => {
                const _item = Object.assign({}, item);
                Reflect.deleteProperty(_item, 'resolve');
                Reflect.deleteProperty(_item, 'reject');
                return _item;
            }),
            taskListInProcess: [...this.taskListInProcess.values()].filter(item => item.requestContent.account === account),
        };
    }
    async registerTaskHandleWin2Main() {
        return true;
    }
    configDelayrejectAboutTask(args) {
        const { seqNo, requestContent } = args;
        const key = [requestContent.namespace, requestContent.apiname].join('.');
        console.log('[bridge]configDelayrejectAboutTask1', 'key is:', key);
        const priorityAndOvertime = (this.priorityConfigMap.has(key)
            ? this.priorityConfigMap.get(key)
            : {
                priority: 'meidum',
                overtime: MainBridgeEngine.DefaultTimeoutResponseTime.get('medium'),
            });
        if (priorityAndOvertime.priority === 'low') {
            return;
        }
        const timeoutFunc = () => {
            const taskStackList = this.taskStackMap.get(requestContent.account);
            [taskStackList.highTasks, taskStackList.mediumTasks, taskStackList.timeoutTasks].some(stacklist => {
                const index = stacklist.findIndex(item => item.seqNo === seqNo);
                if (index === -1) {
                    return false;
                }
                const taskInfo = stacklist[index];
                typeof taskInfo.reject === 'function' && taskInfo.reject(new Error(BRIDGE_RESPONSE_TYPE.API_RESPONSE_TIMEOUT));
                stacklist.splice(index, 1);
                return true;
            });
            if (this.taskListInProcess.has(seqNo)) {
                this.doReturn2JobQ({
                    ackNo: seqNo,
                    code: BRIDGE_RESPONSE_CODE.API_RESPONSE_TIMEOUT,
                    errorMsg: BRIDGE_RESPONSE_TYPE.API_RESPONSE_TIMEOUT,
                });
            }
        };
        const $t = setTimeout(() => {
            timeoutFunc();
        }, priorityAndOvertime.overtime);
        this.responseTimeoutManageMap.set(seqNo, $t);
    }
    async checkBgAlive(account) {
        const totalList = [...this.bgDataWinList.values()];
        const winList = totalList.filter(item => item.status === 'connect').filter(item => item.account === account);
        const now = Date.now();
        const flag1 = winList.length > 0;
        const flag2 = winList.some(item => now - item.timestamp <= MainBridgeEngine.WinMaxAliveDuration);
        return Promise.resolve(flag1 && flag2);
    }
    async dispatchTask(e, args) {
        console.log('[web-bridge]main.dispatchTask start:', e, args);
        const taskAccount = args.requestContent.account;
        if (typeof taskAccount !== 'string' || !taskAccount.length) {
            return Promise.reject(new Error(BRIDGE_RESPONSE_TYPE.INVALD_ACCOUNT_NOACCOUNT));
        }
        const hasTaskWin = await this.checkBgAlive(taskAccount);
        if (!hasTaskWin) {
            return Promise.reject(new Error(BRIDGE_RESPONSE_TYPE.BG_WIN_NOT_EXIST));
        }
        console.log('[bridge]pushtask', JSON.stringify(args));
        const now = Date.now();
        const key = [args.requestContent.namespace, args.requestContent.apiname].join('.');
        const priority = this.priorityConfigMap.has(key) ? this.priorityConfigMap.get(key).priority : 'medium';
        this.configDelayrejectAboutTask(args);
        this.consumingDurationManageMap.set(args.seqNo, now);
        if (priority === 'high' || priority === 'medium') {
            const duration = priority === 'high' ? 200 : 500;
            return new Promise((resolve, reject) => {
                const taskDetail = Object.assign(Object.assign({}, args), { overtime: now + duration, resolve,
                    reject });
                const taskList = this.taskStackMap.get(taskAccount)[priority === 'high' ? 'highTasks' : 'mediumTasks'];
                taskList.push(taskDetail);
            });
        }
        if (priority === 'low') {
            const duration = 1000 * 20;
            const taskDetail = Object.assign(Object.assign({}, args), { overtime: now + duration });
            const taskList = this.taskStackMap.get(taskAccount).lowTasks;
            taskList.push(taskDetail);
            this.taskStackMap.get(taskAccount).lowTasks.push(taskDetail);
            return Promise.resolve(true);
        }
        return Promise.reject(new Error('NO_PRIORITY'));
    }
    async doReturn2JobQ(response) {
        const { ackNo } = response;
        if (!this.taskListInProcess.has(ackNo)) {
            return;
        }
        if (this.responseTimeoutManageMap.has(ackNo)) {
            const t = this.responseTimeoutManageMap.get(ackNo);
            clearTimeout(t);
            this.responseTimeoutManageMap.delete(ackNo);
        }
        const { channelId } = this.taskListInProcess.get(ackNo);
        console.log(`[bridge]returntask.ackNo:${ackNo}.exist:${this.taskListInProcess.has(ackNo)}`);
        console.log(`[bridge]returntask.winID:${channelId}`);
        this.taskListInProcess.delete(ackNo);
        let durationList;
        if (this.consumingDurationManageMap.has(response.ackNo)) {
            const bgDuration = Array.isArray(response.duration) ? response.duration : [];
            durationList = [this.consumingDurationManageMap.get(response.ackNo), ...bgDuration];
        }
        this.mainChannelApi.send2Render(channelId, {
            type: 'response',
            ackNo,
            code: response.code,
            data: response.code === 0 ? response.data : undefined,
            errorMsg: response.errorMsg,
            duration: durationList,
        });
        this.consumingDurationManageMap.delete(response.ackNo);
    }
    initTaskMap(taskAccount) {
        if (this.taskStackMap.has(taskAccount)) {
            return;
        }
        const taskStackList = {
            highTasks: [],
            mediumTasks: [],
            lowTasks: [],
            timeoutTasks: [],
        };
        this.taskStackMap.set(taskAccount, taskStackList);
    }
    async returnTaskResult(e, args) {
        const { response, options } = args;
        const channelId = e.data.channelId;
        this.delayDetectBgWin(channelId, options.account);
        this.initTaskMap(options.account);
        setTimeout(async () => {
            if (!args.response || !this.taskListInProcess.has(args.response.ackNo)) {
                return;
            }
            try {
                await this.doReturn2JobQ(response);
            }
            catch (ex) {
                console.error('[bridge]returnTaskResult.doReturn2JobQ error', ex);
            }
        }, 0);
        try {
            const res = await this.pullTasks(channelId, options);
            return res;
        }
        catch (ex) {
            this.pullingLockMap.set(channelId, false);
            return Promise.resolve(options.count > 0
                ? [
                    {
                        seqNo: `RESIDENT-ERRORTASK-${Math.random()}`,
                        requestContent: {
                            namespace: 'common',
                            apiname: 'residentTask',
                            args: [
                                {
                                    random: Math.random(),
                                },
                            ],
                        },
                        webId: -999,
                    },
                ]
                : []);
        }
    }
    async pullTasks(channelId, options) {
        const { count, account } = options;
        if ((this.pullingLockMap.get(channelId) || count <= 0) && !options.forcePullTask) {
            return Promise.resolve([]);
        }
        this.pullingLockMap.set(channelId, true);
        const now = Date.now();
        if (now - (this.traverseTimeMap.get(channelId) || 0) > MainBridgeEngine.traverDuration) {
            this.traverseTaskDueTime(account);
            this.traverseTimeMap.set(channelId, now);
        }
        await this.waitTask(account, count);
        if (!this.taskStackMap.has(account) || Object.values(this.taskStackMap.get(account)).flat().length === 0) {
            this.pullingLockMap.set(channelId, false);
            return Promise.resolve([
                {
                    seqNo: `RESIDENT-EMPTYTASK-${Math.random()}`,
                    requestContent: {
                        namespace: 'common',
                        apiname: 'residentTask',
                        args: [{ random: Math.random() }],
                    },
                    webId: -999,
                },
            ]);
        }
        let list = [];
        const { highTasks, mediumTasks, lowTasks, timeoutTasks } = this.taskStackMap.get(account);
        if (timeoutTasks.length) {
            const _timeoutTasks = timeoutTasks.splice(0, count);
            _timeoutTasks.forEach(item => {
                const { resolve } = item;
                typeof resolve === 'function' && resolve(true);
            });
            _timeoutTasks.map(item => {
                Reflect.deleteProperty(item, 'resolve');
                Reflect.deleteProperty(item, 'reject');
                return item;
            });
            list = list.concat(_timeoutTasks);
        }
        if (list.length < count && highTasks.length) {
            const _highTasks = highTasks.splice(0, count - list.length);
            _highTasks.forEach(item => {
                const { resolve } = item;
                typeof resolve === 'function' && resolve(true);
            });
            _highTasks.map(item => {
                Reflect.deleteProperty(item, 'resolve');
                Reflect.deleteProperty(item, 'reject');
                return item;
            });
            list = [...list, ..._highTasks];
        }
        if (list.length < count && mediumTasks.length > 0) {
            const _mediumTasks = mediumTasks.splice(0, count - list.length);
            _mediumTasks.forEach(item => {
                const { resolve } = item;
                typeof resolve === 'function' && resolve(true);
            });
            _mediumTasks.map(item => {
                Reflect.deleteProperty(item, 'resolve');
                Reflect.deleteProperty(item, 'reject');
                return item;
            });
            list = [...list, ..._mediumTasks];
        }
        if (list.length < count) {
            const enableExcuteLowTaskCount = Math.min(count, this.getEnableLowTasksSize(channelId));
            const _lowTasks = lowTasks.splice(0, enableExcuteLowTaskCount);
            list = [...list, ..._lowTasks];
        }
        this.taskListInProcess = new Map([...this.taskListInProcess, ...new Map(list.map(item => [item.seqNo, item]))]);
        if (list.length < count) {
            list.push({
                seqNo: `RESIDENT-TASK-${Math.random()}`,
                requestContent: {
                    namespace: 'common',
                    apiname: 'residentTask',
                    args: [{ random: Math.random() }],
                    account: options.account,
                },
                channelId: 'resident-999',
            });
        }
        const consumingNow = Date.now();
        list.forEach(item => {
            if (!this.consumingDurationManageMap.has(item.seqNo)) {
                return;
            }
            const startTime = this.consumingDurationManageMap.get(item.seqNo);
            this.consumingDurationManageMap.set(item.seqNo, consumingNow - startTime);
        });
        this.pullingLockMap.set(channelId, false);
        return Promise.resolve(list);
    }
    async waitTask(account, count) {
        let waitCount = 1;
        const maxWaitCount = 40;
        let hasTasks = false;
        let $tHandle = null;
        const getTaskCount = (account, list) => {
            let totalCount = 0;
            const taskStack = this.taskStackMap.get(account);
            list.forEach(key => {
                totalCount += taskStack[key].length;
            });
            return totalCount;
        };
        const waitFunc = (resolve) => {
            const totalTaskCount = this.taskStackMap.has(account) ? getTaskCount(account, ['highTasks', 'mediumTasks', 'mediumTasks']) : 0;
            const highTaskCount = this.taskStackMap.has(account) ? getTaskCount(account, ['highTasks', 'timeoutTasks']) : 0;
            if (totalTaskCount >= count || waitCount >= maxWaitCount || hasTasks || highTaskCount > 0) {
                resolve(2);
                return;
            }
            if (totalTaskCount > 0) {
                hasTasks = true;
                $tHandle = setTimeout(() => {
                    waitFunc(resolve);
                }, 50);
                return;
            }
            waitCount += 1;
            $tHandle = setTimeout(() => {
                waitFunc(resolve);
            }, 50);
        };
        await new Promise(resolve => {
            waitFunc(resolve);
        });
        $tHandle && clearTimeout($tHandle);
        return true;
    }
    delayDetectBgWin(channelId, account) {
        this.bgDataWinList.set(channelId, {
            timestamp: Date.now(),
            account,
            status: 'connect',
        });
    }
    getEnableLowTasksSize(channelId) {
        console.log('[web-bridge]getEnableLowTasksSize:', channelId);
        const taskCountInProcess = [...this.taskListInProcess.values()].length;
        return Math.max(MainBridgeEngine.MaxLowPriorityCount - taskCountInProcess, 0);
    }
    traverseTaskDueTime(account) {
        if (!this.taskStackMap.has(account)) {
            return;
        }
        const nowTime = Date.now();
        const { highTasks, mediumTasks, timeoutTasks } = this.taskStackMap.get(account);
        const unDueHighTaskIndex = highTasks.findIndex(item => {
            const { overtime } = item;
            return overtime > nowTime;
        });
        const unDueMediumTaskIndex = mediumTasks.findIndex(item => {
            const { overtime } = item;
            return overtime > nowTime;
        });
        if (unDueHighTaskIndex > 0) {
            this.taskStackMap.get(account).timeoutTasks = [...timeoutTasks, ...highTasks.splice(0, unDueHighTaskIndex)];
        }
        if (unDueMediumTaskIndex > 0) {
            this.taskStackMap.get(account).timeoutTasks = [...timeoutTasks, ...mediumTasks.splice(0, unDueMediumTaskIndex)];
        }
    }
}
MainBridgeEngine.DEFAULT_WORKER_WEBID = 1;
MainBridgeEngine.DefaultTimeoutResponseTime = new Map([
    ['high', 20 * 1000],
    ['medium', 30 * 1000],
]);
MainBridgeEngine.traverDuration = 100;
MainBridgeEngine.MaxLowPriorityCount = 2;
MainBridgeEngine.WinMaxAliveDuration = 20 * 1000;
